import { Box, Tooltip, Typography } from "@mui/material";

export function getEndpointId(endpoint) {
  return typeof endpoint === "string" ? endpoint : endpoint?.id;
}

export function normalizeKey(value) {
  return String(value || "").toLowerCase().replace(/\s+/g, " ").trim();
}

export function graphLinkKey(link) {
  return `${getEndpointId(link.source)}|${getEndpointId(link.target)}|${link.linkType || ""}`;
}

export function hexToRgba(hex, alpha) {
  if (!hex || typeof hex !== "string") {
    return `rgba(158, 176, 197, ${alpha})`;
  }

  const normalized = hex.startsWith("#") ? hex.slice(1) : hex;
  if (normalized.length !== 6) {
    return `rgba(158, 176, 197, ${alpha})`;
  }

  const r = Number.parseInt(normalized.slice(0, 2), 16);
  const g = Number.parseInt(normalized.slice(2, 4), 16);
  const b = Number.parseInt(normalized.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function prettifyCategory(value) {
  if (!value) return "Unknown";
  return value
    .split(/[\s_-]+/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function appendListParams(params, name, values) {
  (values || []).forEach((value) => {
    if (typeof value === "string" && value.trim() !== "") {
      params.append(name, value);
    }
  });
}

export function InfoHint({ title }) {
  return (
    <Tooltip
      arrow
      placement="top"
      title={<Box sx={{ fontSize: "0.76rem", lineHeight: 1.45, maxWidth: 280 }}>{title}</Box>}
    >
      <Box component="span" className="network-graph__info-dot">
        i
      </Box>
    </Tooltip>
  );
}

export function ControlCardHeader({ icon, title, info }) {
  return (
    <Box className="network-graph__control-heading">
      <Box component="img" src={icon} alt="" className="network-graph__control-icon" />
      <Typography className="network-graph__control-title">{title}</Typography>
      {info ? <InfoHint title={info} /> : null}
    </Box>
  );
}

export function LegendDot({ color }) {
  return (
    <Box
      component="span"
      className="network-graph__legend-dot"
      sx={{ backgroundColor: color }}
    />
  );
}

export function LabelWithInfo({ label, info, color }) {
  return (
    <Box className="network-graph__label-with-info">
      {color ? <LegendDot color={color} /> : null}
      <span>{label}</span>
      <InfoHint title={info} />
    </Box>
  );
}
